<template>
  <div class="stock">
    <el-form
      label-position="right"
      :inline="true"
      :model="orderForm"
      class="demo-form-inline"
      label-width="65px"
    >
      <el-form-item label="商品编码">
        <el-input
          @keyup.enter.native="searchGoodsList"
          v-model.trim="orderForm.self_code"
          placeholder="商品编码"
        ></el-input>
      </el-form-item>
      <el-form-item label="锐锢编码" label-width="65px">
        <el-input
          @keyup.enter.native="searchGoodsList"
          v-model.trim="orderForm.ruigu_code"
          placeholder="锐锢编码"
        ></el-input>
      </el-form-item>
      <el-form-item label="商品名称" label-width="65px">
        <el-input
          @keyup.enter.native="searchGoodsList"
          v-model="orderForm.name"
          placeholder="商品名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="价格审核状态" label-width="95px">
        <el-select
          v-model="orderForm.audit_status"
          placeholder="请选择"
          clearable
        >
          <el-option label="待审核" value="1"></el-option>
          <el-option label="审核通过" value="2"></el-option>
          <el-option label="审核不通过" value="-1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="分类" label-width="65px">
        <el-input
          @keyup.enter.native="searchGoodsList"
          v-model="orderForm.c_name"
          placeholder="分类"
        ></el-input>
      </el-form-item>
      <el-form-item label="品牌" label-width="65px">
        <el-input
          @keyup.enter.native="searchGoodsList"
          v-model="orderForm.b_name"
          placeholder="品牌"
        ></el-input>
      </el-form-item>
      <el-form-item label="商品状态" label-width="65px">
        <el-select v-model="orderForm.is_enable" placeholder="请选择" clearable>
          <el-option label="全部" value=""></el-option>
          <el-option label="启用" value="1"></el-option>
          <el-option label="停用" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商品类型" v-if="isDeposit">
        <el-select
          v-model="orderForm.is_deposit"
          placeholder="请选择"
          clearable
        >
          <el-option label="定金购商品" value="1"></el-option>
          <el-option label="非定金购商品" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" @click="searchGoodsList"
          >查询</el-button
        >
        <el-button type="primary" size="small" @click="exportOrder"
          >导出</el-button
        >
        <!--<el-button type="primary" @click="serachOrder">增行</el-button>-->
      </el-form-item>
    </el-form>

    <div class="batchbox" v-show="true">
      <div class="info">
        <!--        <div class="tableStatus">-->
        <!--          &lt;!&ndash; tab栏 &ndash;&gt;-->
        <!--          <div>-->
        <!--            <div-->
        <!--              class="status"-->
        <!--              @click="getTableStatus(1)"-->
        <!--              :class="{ active: statusActive === 1 }"-->
        <!--            >-->
        <!--              <p>在售商品</p>-->
        <!--            </div>-->
        <!--            <div-->
        <!--              class="status"-->
        <!--              @click="getTableStatus(2)"-->
        <!--              :class="{ active: statusActive === 2 }"-->
        <!--            >-->
        <!--              <p>下架商品</p>-->
        <!--            </div>-->
        <!--            <div-->
        <!--              class="status"-->
        <!--              @click="getTableStatus(3)"-->
        <!--              :class="{ active: statusActive === 3 }"-->
        <!--            >-->
        <!--              <p>缺货商品</p>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <el-form
          class="demo-form-inline11"
          :inline="true"
          :model="stockNumForm"
          ref="stockNumForm"
          :rules="rules"
          :show-message="false"
          :hide-required-asterisk="true"
        >
          <el-form-item label="库存数量" prop="type" label-width="70px">
            <el-select
              v-model="stockNumForm.type"
              placeholder="请选择"
              clearable
            >
              <el-option label="介于" value="bt"></el-option>
              <el-option label="小于" value="lt"></el-option>
              <el-option label="大于" value="gt"></el-option>
              <el-option label="等于" value="et"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label=""
            prop="minNum"
            v-if="stockNumForm.type === 'bt'"
            label-width="5px"
          >
            <el-input
              @keyup.enter.native="searchGoodsList"
              v-model="stockNumForm.minNum"
              placeholder="库存数量"
            ></el-input>
          </el-form-item>
          <span v-if="stockNumForm.type === 'bt'" class="inline-line">-</span>
          <el-form-item label="" prop="maxNum" label-width="5px">
            <el-input
              @keyup.enter.native="searchGoodsList"
              v-model="stockNumForm.maxNum"
              placeholder="库存数量"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              style="
                        background: none;
                        border: 1px solid #dcdfe6;
                        color: #999;
                     "
              size="small"
              @click="searchStockCountHandler"
              ><i class="el-icon-search"></i
            ></el-button>
            <el-tooltip
              content="不支持和其他值一起查询,若设置该项,其他项设置的值会被清空。（如数量、分类等不能同时设置查询）"
              placement="bottom"
              effect="light"
            >
              <span class="el-icon-question" style="color: #999"></span>
            </el-tooltip>
            <span style="color: #999; font-size: 10px">
              (仅支持单一查询)
            </span>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-dropdown
          trigger="click"
          size="medium"
          placement="bottom"
          class="batchbtn m-r-10"
        >
          <el-button type="primary" size="small">
            数据导出
            <i class="el-icon-caret-bottom el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="exportData(1)"
              >在售商品导出</el-dropdown-item
            >
            <el-dropdown-item @click.native="exportData(2)"
              >下架商品导出</el-dropdown-item
            >
            <el-dropdown-item @click.native="exportData(3)"
              >缺货商品导出</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
        <el-button type="primary" size="small" @click="handleAddStoragePos"
          >添加库位</el-button
        >
        <el-dropdown
          trigger="click"
          size="medium"
          placement="bottom"
          class="batchbtn"
        >
          <el-button type="primary" size="small">
            批量设置
            <i class="el-icon-caret-bottom el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="dialogExelVisible = true"
              >导出模版</el-dropdown-item
            >
            <el-dropdown-item
              @click.native="dialogdaoru = true"
              v-if="shopStatus === 1 || shopStatus === -1"
              >导入数据</el-dropdown-item
            >
            <el-dropdown-item v-if="shopStatus === -2">
              <el-tooltip
                content="店铺已停用，若需维护，请先启用店铺"
                placement="bottom"
                effect="light"
              >
                <span style="color: #999">导入数据</span>
              </el-tooltip>
            </el-dropdown-item>
            <el-dropdown-item @click.native="importrecord"
              >导入记录日志</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <el-dialog
      title="选择导出模版类型"
      width="440px"
      append-to-body
      center
      :visible.sync="dialogExelVisible"
      top="250px"
    >
      <div class="exportbtnbox">
        <el-button type="text" size="mini" @click="exportTemplate(4)"
          >商品编码</el-button
        >
        <el-button type="text" size="mini" @click="exportTemplate(1)"
          >数量</el-button
        >
        <el-button type="text" size="mini" @click="exportTemplate(2)"
          >待审核价格</el-button
        >
        <el-button type="text" size="mini" @click="exportTemplate(3)"
          >库位</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="选择导入数据类型"
      width="440px"
      append-to-body
      center
      :visible.sync="dialogdaoru"
      top="250px"
    >
      <div class="exportbtnbox">
        <!-- <el-button type="text" size="mini">
          数量
          <input type="file" class="inputfile" @change="importf($event,1)" />
        </el-button> -->
        <!-- <el-button type="text" size="mini">
          待审核价格
          <input type="file" class="inputfile" @change="importf($event,2)" />
        </el-button> -->
        <upload-excel-component
          :on-success="results => handleSuccess(results, 4)"
          style="display: inline-block; margin-left: 10px"
          >商品编码</upload-excel-component
        >
        <upload-excel-component
          :on-success="results => handleSuccess(results, 1)"
          style="display: inline-block; margin-left: 10px"
          >数量</upload-excel-component
        >
        <upload-excel-component
          :on-success="results => handleSuccess(results, 2)"
          style="display: inline-block; margin-left: 10px"
          >待审核价格</upload-excel-component
        >
        <upload-excel-component
          :on-success="results => handleSuccess(results, 3)"
          style="display: inline-block; margin-left: 10px"
          >库位</upload-excel-component
        >
        <!-- <el-button type="text" size="mini">
          库位
          <input type="file" class="inputfile" @change="importf($event,2)" />
        </el-button>-->
      </div>
    </el-dialog>
    <el-dialog
      title="请输入需要关联的库位"
      append-to-body
      center
      :visible.sync="isShowAddStoragePosDialog"
      top="250px"
      width="400px"
      @close="closeStoragePosDialog"
    >
      <div class="exportbtnbox">
        <el-input
          type="textarea"
          autosize
          resize="none"
          placeholder="请输入库位"
          v-model="storagePos"
        ></el-input>
        <div class="add-margin">
          <el-button @click="closeStoragePosDialog">取 消</el-button>
          <el-button
            type="primary"
            class="button-bg-color"
            @click="saveStoragePosDialog"
            >确 定</el-button
          >
        </div>
      </div>
    </el-dialog>
    <stock-table
      class="stockTable"
      v-loading="loadingStock"
      @updateTable="getGoodsList"
      :stockTableData="stockTableData"
      :showindex="true"
      @handleShowAddStoragePos="handleShowAddStoragePos"
      :templateshow="true"
    ></stock-table>
    <!-- <stock-table
    class="stockTableTemplate" :stockTableData='stockTableData' v-show="false" :showindex="false" :templateshow="true">
    </stock-table>
    <stock-table
    class="stockTableTemplateempty" :stockTableData='stockTableData' v-show="false" :showindex="false" :templateshow="false">
    </stock-table>-->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 50, 100, 200]"
      :page-size="pagesize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalCount"
    ></el-pagination>
  </div>
</template>
<script>
import XLSX from "xlsx";
// import FileSaver from 'file-saver'
// import { currentTime } from '@/utils/utils'
import UploadExcelComponent from "@/components/common/UploadExcel/index.vue";
import {
  getGoodsList,
  importData,
  importCodeData, // 紧固件下 商品编码导入
  exportStockData,
  doExportData,
  updateStoragePos,
  getStockCountList
} from "@/models/goodsModel";
import stockTable from "@/components/stock/stock-table.vue";
import goodsApiList from "../../service/basic/goodsApiList";

const storagePosParams = {
  shop_id: "",
  ruigu_code: "",
  storage_pos: ""
};
const checkNum = value => {
  if (value === 0) {
    return "success";
  } else if (!value) {
    return "数量不能为空";
  }
  if (!/(^-?[0-9]\d*$)/.test(value)) {
    return "请填写整数";
  } else {
    if (value.length > 6) {
      return "请填写6位数以内的整数";
    } else {
      return "success";
    }
  }
};
const checkEmpty = function(params) {
  let args = Array.prototype.slice.call(arguments);
  for (const item of args) {
    if (!item) {
      return "商品编码或数量为空，请重新填写";
    }
  }
  return "success";
};
const checkCodeEmpty = function(params) {
  let args = Array.prototype.slice.call(arguments);
  for (const item of args) {
    if (!item) {
      return "锐锢商品码或商品编码为空，请重新填写";
    }
  }
  return "success";
};
const initImportData = (value, fixed2) => {
  if (typeof value === "number") {
    let num = new Number(value);
    if (fixed2) {
      return num.toFixed(2) + "";
    } else {
      return num + "";
    }
  }
  if (typeof value === "string") {
    return String(value + "").trim();
  }
  return "";
};
export default {
  components: { stockTable, UploadExcelComponent },
  data() {
    return {
      orderForm: {
        self_code: "",
        ruigu_code: "",
        c_name: "",
        b_name: "",
        name: "",
        audit_status: "",
        is_enable: "1",
        is_deposit: undefined
      },
      stockNumForm: {
        type: "",
        minNum: "",
        maxNum: ""
      },
      stockTableData: [],
      loadingStock: "",
      currentPage: 1,
      totalCount: 0,
      pagesize: 10,
      dialogExelVisible: false,
      dialogdaoru: false,
      canUseAddStoragePos: false,
      isShowAddStoragePosDialog: false,
      storagePos: "",
      shopStatus: "",
      searchType: "default", // 默认按getGoodsList方法查询 StockCount为按库存查询
      rules: {
        minNum: [{ required: true, message: "请输入库存数量" }],
        maxNum: [{ required: true, message: "请输入库存数量" }],
        type: [{ required: true, message: "请选择条件" }]
      },
      isJgj: localStorage.getItem("is_jgj") === "1",
      statusActive: 1,
      isDeposit: localStorage.getItem("is_deposit")
    };
  },
  mounted() {
    let enable = localStorage.getItem("is_enable");
    let status = localStorage.getItem("close_status");
    if (enable == "1") {
      this.shopStatus = 1;
    } else {
      if (status == "1") {
        this.shopStatus = -1;
      }
      if (status == "2") {
        this.shopStatus = -2;
      }
    }
    // 店铺已通用，若需维护，请先启用店铺
    this.getGoodsList();
  },
  methods: {
    /**
     * 表格tab切换 todo 根据tab调接口传参
     */
    getTableStatus(index) {
      this.currentPage = 1;
      this.statusActive = index;
      this.stockTableData = [];
      this.pagesize = 10;
      this.getGoodsList();
    },
    /**
     * 添加库位
     * @param sign      // 对话框展示标记
     * @param shopId    // 店铺id
     * @param ruiguCode // 锐锢商城商品编码
     */
    handleShowAddStoragePos(sign = false, shopId = "", ruiguCode = "") {
      this.canUseAddStoragePos = sign;
      storagePosParams.shop_id = sign ? shopId : "";
      storagePosParams.ruigu_code = sign ? ruiguCode : "";
    },
    // 导入excel
    async handleSuccess({ results, header }, type) {
      if (results.length > 0) {
        if (type === 1) {
          this.importNum(results, header);
        }
        if (type === 2) {
          this.importPrice(results, header);
        }
        // 库位单独判断导入数据校验
        if (type === 3) {
          this.importPlace(results, header);
        }
        if (type === 4) {
          this.importProCode(results, header);
        }
      } else {
        this.$message.error("请填写数据");
      }
    },

    async importNum(results, header) {
      let numArr = ["序号", "商品编码", "商品名称", "数量"];
      if (this.filterAllLabel(header, numArr)) {
        let data = results.map(item => {
          return {
            id: initImportData(item["序号"]),
            sku: initImportData(item["商品编码"]),
            name: initImportData(item["商品名称"]),
            num: initImportData(item["数量"])
          };
        });
        console.log(data);
        if (this.filterDuplicate(data)) {
          for (const item of data) {
            let skumsg = checkEmpty(item.sku, item.num);
            let nummsg = checkNum(item.num);
            if (skumsg !== "success") {
              return this.$message.error(skumsg);
            } else if (nummsg !== "success") {
              return this.$message.error(nummsg);
            }
          }
          let params = {
            datas: JSON.stringify(data),
            type: 1
          };
          await importData(params);
          this.getGoodsList();
          // if (vaild) {
          // } else {
          //   this.$message.error('商品编码或数量为空，请重新填写')
          // }
        } else {
          this.$message.error("商品编码重复，请重新填写");
        }
      } else {
        this.$message.error("请检查表头是否有误");
      }
    },
    // 商品编码导入
    async importProCode(results, header) {
      let numArr = ["序号", "锐锢商品码", "商品名称", "三方商品编码"];
      if (this.filterAllLabel(header, numArr)) {
        console.log(results);
        let data = results.map(item => {
          return {
            id: initImportData(item["序号"]),
            sku_code: initImportData(item["锐锢商品码"]),
            name: initImportData(item["商品名称"]),
            self_code: initImportData(item["三方商品编码"])
          };
        });
        if (this.filterProCode(data)) {
          for (const item of data) {
            let skumsg = checkCodeEmpty(item.sku_code, item.self_code);
            // let nummsg = checkNum(item.num)
            if (skumsg !== "success") {
              return this.$message.error(skumsg);
            }
            // else if(nummsg !== 'success'){
            //   return this.$message.error(nummsg)
            // }
          }
          let params = {
            datas: JSON.stringify(data)
            // type: 1
            // shop_id:localStorage.getItem('shop_id')
          };
          console.log(params);
          await importCodeData(params);
          this.getGoodsList();
          // if (vaild) {
          // } else {
          //   this.$message.error('商品编码或数量为空，请重新填写')
          // }
        } else {
          this.$message.error("锐锢商品码或商品编码重复，请重新填写");
        }
      } else {
        this.$message.error("请检查表头是否有误");
      }
    },
    async importPrice(results, header) {
      console.log("header--:", header);
      let priceArr = ["序号", "商品编码", "商品名称", "待审核价格"];
      if (this.filterAllLabel(header, priceArr)) {
        let data = results.map(item => {
          return {
            id: initImportData(item["序号"]),
            sku: initImportData(item["商品编码"]),
            name: initImportData(item["商品名称"]),
            num: initImportData(item["待审核价格"], true)
          };
        });
        if (this.filterDuplicate(data)) {
          let vaild = data.every(item => {
            return item.sku && item.num;
          });
          console.log(vaild, "vaild");
          if (vaild) {
            let params = {
              datas: JSON.stringify(data),
              type: 2
            };
            await importData(params);
            this.getGoodsList();
          } else {
            this.$message.error("商品编码或待审核价格为空，请重新填写");
          }
        } else {
          this.$message.error("商品编码重复，请重新填写");
        }
      } else {
        this.$message.error("请检查表头是否有误");
      }
    },
    async importPlace(results, header) {
      let stockArr = ["序号", "商品编码", "商品名称", "库位"];
      let data = [];
      if (this.filterAllLabel(header, stockArr)) {
        let tip = results[0];
        console.log(tip, "tip");
        if (tip["序号"].includes("提示信息")) {
          results.splice(0, 1);
          console.log(results, "results");
          if (results.length > 0) {
            data = results.map(item => {
              return {
                id: initImportData(item["序号"]),
                sku: initImportData(item["商品编码"]),
                name: initImportData(item["商品名称"]),
                num: initImportData(item["库位"])
              };
            });
            if (this.filterDuplicate(data)) {
              let vaild = data.every(item => {
                return item.sku && item.num;
              });
              if (vaild) {
                let params = {
                  datas: JSON.stringify(data),
                  type: 3
                };
                await importData(params);
                this.getGoodsList();
              } else {
                this.$message.error("商品编码或库位为空，请重新填写");
              }
            } else {
              this.$message.error("商品编码重复，请重新填写");
            }
          } else {
            this.$message.error("请填写数据");
          }
        } else {
          this.$message.error("模版格式错误，请重新检查模版");
        }
      } else {
        this.$message.error("请检查表头是否有误");
      }
    },
    filterDuplicate(soure) {
      let arr = soure.map(item => {
        return item.sku;
      });
      let filterArr = [...new Set(arr)];
      if (arr.length === filterArr.length) {
        return true;
      } else {
        return false;
      }
    },
    // 判断商品编码和锐锢商城编码不能重复
    filterProCode(soure) {
      let sku_code = soure.map(item => {
        return item.sku_code;
      });
      let self_code = soure.map(item => {
        return item.self_code;
      });
      let filterArr = [...new Set(sku_code)];
      let filterArr2 = [...new Set(self_code)];
      console.log(filterArr);
      console.log(filterArr2);
      if (
        sku_code.length === filterArr.length &&
        self_code.length === filterArr2.length
      ) {
        return true;
      } else {
        return false;
      }
    },
    formatJson(filterVal, jsonData, type) {
      return jsonData.map(v =>
        filterVal.map(j => {
          return v[j];
        })
      );
    },
    filterAllLabel(labels, template) {
      labels.sort();
      template.sort();
      console.log("labels--", labels);
      console.log("template--", template);
      let labelsT = JSON.stringify(labels);
      let templateT = JSON.stringify(template);
      if (labelsT === templateT) {
        return true;
      } else {
        return false;
      }
    },
    handleAddStoragePos() {
      if (!this.canUseAddStoragePos) {
        this.$message.warning("请先勾选商品！");
        return;
      }
      this.isShowAddStoragePosDialog = true;
    },
    closeStoragePosDialog() {
      this.storagePos = "";
      storagePosParams.storage_pos = "";
      this.isShowAddStoragePosDialog = false;
    },
    saveStoragePosDialog() {
      storagePosParams.storage_pos = this.storagePos || "";

      if (
        storagePosParams.shop_id === "" ||
        storagePosParams.ruigu_code === ""
      ) {
        this.$message.warning("数据错误，请刷新页面后重试!");
        return;
      }
      if (storagePosParams.storage_pos === "") {
        this.$message.warning("请输入库位!");
        return;
      }

      updateStoragePos(storagePosParams)
        .then(res => {
          if (res.code === 200 && res.data) {
            this.$message.success("库位添加成功!");
          } else {
            this.$message.error("库位添加失败!");
          }
          this.resetStorageParam();
          this.getGoodsList();
        })
        .catch(e => {
          this.resetStorageParam();
          this.$message.error("库位添加失败!");
        });
      this.isShowAddStoragePosDialog = false;
    },
    resetStorageParam() {
      this.storagePos = "";
      storagePosParams.shop_id = "";
      storagePosParams.ruigu_code = "";
      storagePosParams.storage_pos = "";
    },
    // 默认查询数据
    searchGoodsList() {
      this.$refs["stockNumForm"].resetFields();
      this.initStockCountSearch();
      this.searchType = "default";
      this.currentPage = 1;
      this.getGoodsList();
    },
    async getGoodsList() {
      this.loadingStock = true;
      this.orderForm.pagesize = this.pagesize;
      this.orderForm.page = this.currentPage;
      let params = Object.assign({}, this.orderForm);
      // console.log(params, 'params', params.is_enable !== '0', params.is_enable !== '0')
      if (params.is_enable !== "0" && params.is_enable !== "1") {
        delete params.is_enable;
      }
      let data = await getGoodsList(params);
      if (
        data !== "" &&
        data !== null &&
        data !== "null" &&
        data !== undefined
      ) {
        this.stockTableData = data.list || [];
        for (let i of data.list) {
          i.is_sale = i.is_online === 1 ? "是" : "否";
          i.storage_pos = i.storage_pos || "";
        }
        this.totalCount = data.total;
      }
      setTimeout(() => {
        this.loadingStock = false;
      }, 300);
    },
    handleSizeChange(val) {
      this.pagesize = val;
      if (this.searchType === "default") {
        this.getGoodsList();
      }
      if (this.searchType === "StockCount") {
        this.getStockCountList({
          page: this.currentPage,
          pageSize: this.pagesize
        });
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      if (this.searchType === "default") {
        this.getGoodsList();
      }
      if (this.searchType === "StockCount") {
        this.getStockCountList({
          page: this.currentPage,
          pageSize: this.pagesize
        });
      }
    },
    serachOrder() {},
    async exportOrder() {
      await exportStockData(this.orderForm);
    },
    async exportData(type) {
      // todo
      console.log(88989, type);
      switch (type) {
        case 1:
          window.open(
            echarthostname +
              goodsApiList.exportdata +
              "?shop_id=" +
              localStorage.getItem("shop_id") +
              "&type=1" +
              "&token=" +
              localStorage.getItem("token")
          );
          break;
        case 2:
          window.open(
            echarthostname +
              goodsApiList.exportdata +
              "?shop_id=" +
              localStorage.getItem("shop_id") +
              "&type=2" +
              "&token=" +
              localStorage.getItem("token")
          );
          break;
        case 3:
          window.open(
            echarthostname +
              goodsApiList.exportdata +
              "?shop_id=" +
              localStorage.getItem("shop_id") +
              "&type=3" +
              "&token=" +
              localStorage.getItem("token")
          );
          break;
      }
    },
    // 导出模版
    exportTemplate(val) {
      if (val === 1) {
        // 数量
        import("@/vendor/Export2Excel").then(excel => {
          const tHeader = ["序号", "商品编码", "商品名称", "数量"];
          const filterVal = ["index", "self_code", "name", "num"];
          const list = [];
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: "stock",
            autoWidth: true,
            bookType: "xlsx"
          });
        });
      } else if (val === 2) {
        // 待审核价格
        import("@/vendor/Export2Excel").then(excel => {
          const tHeader = ["序号", "商品编码", "商品名称", "待审核价格"];
          const filterVal = ["index", "self_code", "name", "num"];
          const list = [];
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: "price",
            autoWidth: true,
            bookType: "xlsx"
          });
        });
      } else if (val === 3) {
        import("@/vendor/Export2Excel").then(excel => {
          const tHeader = ["序号", "商品编码", "商品名称", "库位"];
          const filterVal = ["index", "self_code", "name", "num"];
          const list = [
            {
              index:
                "提示信息：若一个商品存在多个库位，请用半角英文状态下的逗号“,”隔开(导入时请不要删除本行)"
            }
          ];
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: "pos",
            autoWidth: false,
            bookType: "xlsx"
          });
        });
      } else if (val === 4) {
        // 商品编码
        import("@/vendor/Export2Excel").then(excel => {
          const tHeader = ["序号", "锐锢商品码", "商品名称", "三方商品编码"];
          const filterVal = ["index", "sku_code", "name", "self_code"];
          const list = [];
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: "code",
            autoWidth: true,
            bookType: "xlsx"
          });
        });
      }
      this.dialogExelVisible = false;
    },
    // 导入数据
    importf(obj, ty) {
      this.dialogdaoru = false;
      let wb; // 读取完成的数据
      let rABS = false; // 是否将文件读取为二进制字符串
      if (!obj.target.files) {
        return;
      }
      var f = obj.target.files[0];
      var reader = new FileReader();
      let that = this;

      reader.onload = async function(e) {
        var data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        for (let i in wb.Sheets["Sheet1"]) {
          let sheetname = wb.Sheets["Sheet1"][i];
          if (sheetname.w !== undefined && sheetname.w === "商品编码") {
            sheetname.w = "sku";
          } else if (
            sheetname.w !== undefined &&
            sheetname.w === "数量" &&
            ty === 1
          ) {
            sheetname.w = "num";
          } else if (
            sheetname.w !== undefined &&
            sheetname.w === "待审核价格" &&
            ty === 2
          ) {
            sheetname.w = "num";
          } else if (sheetname.w !== undefined && sheetname.w === "商品名称") {
            sheetname.w = "name";
          } else if (sheetname.w !== undefined && sheetname.w === "序号") {
            sheetname.w = "id";
          }
        }
        // wb.SheetNames[0]是获取Sheets中第一个Sheet的名字
        // wb.Sheets[Sheet名]获取第一个Sheet的数据
        // document.getElementById("demo").innerHTML= JSON.stringify( XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]) );
        let demodeta = JSON.stringify(
          XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]])
        );
        console.log(demodeta);
        let params = {
          datas: demodeta,
          type: ty
        };
        await importData(params);
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        if (f) {
          reader.readAsBinaryString(f);
        }
      }
      function fixdata(data) {
        // 文件流转BinaryString
        var o = "",
          l = 0,
          w = 10240;
        for (; l < data.byteLength / w; ++l) {
          o += String.fromCharCode.apply(
            null,
            new Uint8Array(data.slice(l * w, l * w + w))
          );
        }
        o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
        return o;
      }
    },
    // 导入记录
    importrecord() {
      this.$router.push({ name: "stockRecord", params: {} });
    },
    // 根据库存数量 查询数据
    getStockCountList({ page, pageSize } = { page: 1, pageSize: 10 }) {
      let params = {};
      params.page_size = pageSize;
      params.page = page;
      // params.pagesize = this.pagesize
      // params.page = this.currentPage
      this.$refs["stockNumForm"].validate(valid => {
        if (valid) {
          params.type = this.stockNumForm.type;
          if (this.stockNumForm.type === "bt") {
            params.vals =
              this.stockNumForm.minNum + "," + this.stockNumForm.maxNum;
          } else {
            params.vals = this.stockNumForm.maxNum;
          }
          this.loadingStock = true;
          getStockCountList(params).then(res => {
            if (
              res.data !== "" &&
              res.data !== null &&
              res.data !== "null" &&
              res.data !== undefined &&
              Object.prototype.toString.call(res.data) !== "[object Array]"
            ) {
              this.stockTableData = res.data.list || [];
              for (let i of res.data.list) {
                i.is_sale = i.is_online === 1 ? "是" : "否";
                i.storage_pos = i.storage_pos || "";
              }
              this.totalCount = res.data.total;
              this.loadingStock = false;
            } else {
              this.stockTableData = [];
              this.loadingStock = false;
            }
          });
        } else {
          this.$message.error("请完善查询信息");
          return false;
        }
      });
    },
    // 根据库存数量 查询数据
    searchStockCountHandler() {
      this.searchType = "StockCount";
      this.initDefalutSearch();
      this.getStockCountList();
    },
    // 查询数量时初始化默认查询
    initDefalutSearch() {
      this.orderForm = {
        self_code: "",
        ruigu_code: "",
        c_name: "",
        b_name: "",
        name: "",
        audit_status: "",
        is_enable: "1",
        is_deposit: undefined
      };
    },

    // 默认查询时初始化数量查询
    initStockCountSearch() {
      this.stockNumForm = {
        type: "",
        minNum: "",
        maxNum: ""
      };
    }
  }
};
</script>
<style lang="scss">
.stock {
  .demo-form-inline {
    .el-button:first-child {
      margin-left: 20px;
    }
  }
  .demo-form-inline {
    padding-bottom: 15px;
    border-bottom: 1px solid #ccc;
  }
  .stock-table[data-v-6c88bc04] {
    border-top: none;
  }
  .batchbox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0 5px 0;
    .batchbtn {
      margin-left: 10px;
    }
    .m-r-10 {
      margin-right: 10px;
    }
  }
  .tableStatus {
    display: flex;
    justify-content: space-between;
    div {
      display: flex;
    }
    .status {
      cursor: pointer;
      height: 30px;
      width: 80px;
      margin-right: 1px;
      margin-top: 5px;
      border-radius: 8px 8px 0px 0px;
      background-color: rgb(115, 129, 140);
      p {
        color: #fff;
        font-size: 14px;
        width: 100%;
        text-align: center;
        line-height: 4px;
      }
    }
    .status.active,
    .status:hover {
      background-color: rgb(164, 180, 193);
    }
  }
}
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  color: #ff6224;
}
.el-dropdown-menu--medium .el-dropdown-menu__item {
  position: relative;
}
.exportbtnbox {
  text-align: center;
  .el-button {
    padding: 10px;
    background: #fff;
    color: #606266;
    border: 1px solid #dcdfe6;
    position: relative;
    .inputfile {
      position: absolute;
      left: 0;
      top: 0;
      opacity: 0;
      height: 100%;
      width: 100%;
    }
  }
  .el-button:hover {
    border-color: #c6e2ff;
    background-color: #ecf5ff;
  }
}
.button-bg-color {
  background-color: #ff6224 !important;
  border-color: #ff6224 !important;
  color: #fff !important;
}
.add-margin {
  margin-top: 20px;
}
.info {
  color: red;
  font-size: 12px;
  display: flex;
}

.inline-line {
  line-height: 40px;
  vertical-align: middle;
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/pages/stock/stock.vue